const complaintMge = r => require.ensure([], () => r(require('@/page/complaintMge/complaintMge')), 'complaintMge');
const recordMge = r => require.ensure([], () => r(require('@/page/complaintMge/recordMge/recordMge')), 'recordMge');
const details = r => require.ensure([], () => r(require('@/page/complaintMge/details/details')), 'details');
const complaintReports = r => require.ensure([], () => r(require('@/page/complaintMge/complaintReports/complaintReports')), 'complaintReports');
const registration = r => require.ensure([], () => r(require('@/page/complaintMge/registration/registration')), 'registration');
const registration1 = r => require.ensure([], () => r(require('@/page/complaintMge/registration/registration1')), 'registration1');
const registrationDetail = r => require.ensure([], () => r(require('@/page/complaintMge/registration/registrationDetail')), 'registrationDetail'); //投诉登记详情
const resultRegistration = r => require.ensure([], () => r(require('@/page/complaintMge/resultRegistration/resultRegistration')), 'resultRegistration');
const statisticalAnalysis = r => require.ensure([], () => r(require('@/page/complaintMge/statisticalAnalysis/statisticalAnalysis')), 'statisticalAnalysis');
const complaintSettling = r => require.ensure([], () => r(require('@/page/complaintMge/recordMge/complaintSettling')), 'complaintSettling');
const complaintSettlingDetail = r => require.ensure([], () => r(require('@/page/complaintMge/recordMge/complaintSettlingDetail')), 'complaintSettlingDetail');
const Signboard = r => require.ensure([], () => r(require('@/page/Signboard/Signboard')), 'Signboard');

export const complaintMgeRouter = {
    path: '',
    name: '投诉管理',
    component: complaintMge,
    meta: {
        icon: 'complaintMge',
        right: [],
        isShowMenu: true,
        keepAlive:true,
    },
    children: [{
            path: '/recordMge',
            component: recordMge,
            name: '投诉记录管理',
            meta: {
                right: ['投诉记录管理'],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        {
            path: '/complaintReports',
            component: complaintReports,
            name: '投诉报告',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        {
            path: '/regist',
            meta: {
                right: [],
                isShowMenu: false,
                workflow: true,
                keepAlive:true,
            }
        },
        {
            path: '/registration',
            component: registration,
            name: '投诉登记',
            meta: {
                right: ['投诉登记'],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/registration1',
            component: registration1,
            name: '投诉登记',
            meta: {
                right: ['投诉登记'],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/registrationDetail',
            component: registrationDetail,
            name: '投诉登记详情',
            meta: {
                right: ['投诉登记详情'],
                isShowMenu: false,
                keepAlive:true,
            },
        }, //投诉登记详情
        {
            path: '/resultRegistration',
            component: resultRegistration,
            name: '投诉结果登记',
            meta: {
                right: ['投诉结果登记'],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        {
            path: '/statisticalAnalysis',
            component: statisticalAnalysis,
            name: '投诉结果分析',
            meta: {
                right: ['投诉量统计分析'],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        {
            path: '/complaintSettling',
            component: complaintSettling,
            name: '投诉处理',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        {
            path: '/complaintSettlingDetail',
            component: complaintSettlingDetail,
            name: '投诉详情',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/details',
            component: details,
            name: '详细信息',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/Signboard',
            component: Signboard,
            name: '签字板测试',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        // { path: '/Signboard', component: Signboard, name: '签字板测试', meta: { right: [], isShowMenu: false }, },

    ]
};
export default complaintMgeRouter;